import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { AuthCard, Field, PrimaryButton, ErrorText } from "./_auth_ui";

export function Verify() {
  const { confirmSignUp, resendCode } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get("email") ?? "");
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError(null); setInfo(null);
    try {
      await confirmSignUp(email, code);
      nav("/signin");
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const onResend = async () => {
    setError(null); setInfo(null);
    try {
      await resendCode(email);
      setInfo("Code resent. Check your email.");
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Could not resend code");
    }
  };

  return (
    <AuthCard title="Check your email" subtitle="Enter the 6-digit code we just sent.">
      <form onSubmit={onSubmit} className="space-y-4">
        <Field label="Email" type="email" value={email} onChange={setEmail} required />
        <Field label="Verification code" value={code} onChange={setCode} placeholder="123456" required />
        <ErrorText error={error} />
        {info && <p className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2">{info}</p>}
        <PrimaryButton loading={loading}>Verify email</PrimaryButton>
      </form>
      <button
        type="button"
        onClick={onResend}
        className="mt-4 w-full text-sm text-neutral-500 hover:text-black transition"
      >
        Didn't get it? Resend code
      </button>
    </AuthCard>
  );
}
